import { CardNavigationPanel } from 'components/CardNavigationPanel';
import { DEFAULT_OPTION } from 'components/CardNavigationPanel/constants';
import { DisplayJobCount } from 'components/DisplayJobCount';
import { useSelector } from 'react-redux';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { MetaDataSelector } from 'redux/features/jobList';
import styles from './index.module.scss';

/** ListControlsのprops */
interface Props {
  /** 最大ページ数 */
  maxPage: number;
}

/**
 * 求人件数・ナビゲーションパネル
 * @param {number} maxPage
 */
export const ListControls: React.FC<Props> = ({ maxPage }) => {
  const { page } = useSelector(appQueryParamsSelector);
  const jobListMeta = useSelector(MetaDataSelector);

  return (
    <div className={styles.careerRecommendJobList__functions}>
      <DisplayJobCount
        totalCount={jobListMeta?.totalCount ?? 0}
        resultCount={jobListMeta?.resultCount ?? 0}
        offset={jobListMeta?.offset ?? 0}
      />
      <CardNavigationPanel
        hasNextPage={(Number(page) || 1) < maxPage}
        orderOptions={[
          DEFAULT_OPTION,
          { label: '資格保有者の興味・関心が高い順', value: '3' },
          { label: '新着順', value: '1' },
          { label: '締切間近順', value: '2' },
        ]}
        isWideSortMenu
      />
    </div>
  );
};
